import {Observable}                from 'rxjs';
import {distinctUntilChanged, map} from 'rxjs/operators';

import FrameStatus from '../Constants/FrameStatus';
import Frame       from '../Frame';

const createFrameStatusChangeStream = (
    frameStoreUpdate$: Observable<Frame>
): Observable<FrameStatus> =>
    frameStoreUpdate$
        .pipe(
            map(nextFrame => nextFrame.frameStatus),
            distinctUntilChanged()
        );

export default createFrameStatusChangeStream;